import { validators, messages } from 'utils/fields/validators'

const useValidate = (rules = {}) => {
  const validate = (value) => {
    const errorMessage = Object.entries(rules).reduce(
      (acc, [validatorName, additionalOption]) => {
        const validator = validators[validatorName]
        const isToValidate = rules[validatorName]
        if (isToValidate && validator && validator(value, additionalOption)) {
          return messages[validatorName](additionalOption)
        }

        return acc
      },
      ''
    )

    return errorMessage
  }

  return validate
}

export { useValidate }
